import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Dialog, Grid, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { CustomAutocomplete } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomAutocomplete';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraDiaMesAno from 'esocial.web.react.lib/cjs/components/form/Validation/RegraDiaMesAno';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepDatePicker } from 'esocial.web.react.lib/cjs/components/form/Vep/VepDatePicker';
import { VepSelect } from 'esocial.web.react.lib/cjs/components/form/Vep/VepSelect';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import Mensagens from 'esocial.web.react.lib/cjs/components/layout/Mensagens';
import { CustomDialogActions, CustomDialogContent, CustomDialogTitle } from 'esocial.web.react.lib/cjs/components/util/Dialog';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { CustomTable } from 'esocial.web.react.lib/cjs/components/util/Table';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { limparMensagens, substituirMensagens } from 'esocial.web.react.lib/cjs/store/reducers/mensagens';
import { abrirModalConfirmacao, fecharModalConfirmacao } from "esocial.web.react.lib/cjs/store/reducers/modais";
import { TipoMensagem } from 'esocial.web.react.lib/cjs/utils/enums';
import { calcularHashDeString, getStringValue, isUndefinedOrNull, obterObjetoTodosComponentesIntocados, obterObjetoTodosComponentesTocados, obterOpcaoAutocompletePorValorVep, retornarFocoParaBotaoChamador, rolarVisualizacaoAteElemento, rolarVisualizacaoAteElementoInvalido, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useRef, useState } from 'react';

const ContainerBotoesTabelaAcao = styled(TableCell)(({ theme }) => ({
    '& > *': {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

const ButtonTextPrimary = styled(IconButton)(({ theme }) => ({
    color: theme.palette.text.primary,
}));

const idBlocoMensagensModalExames = 'mensagens-modal-exames';

const listaProcedimentoObrigatoriedadeObservacaoProcedimento = ['0583', '0998', '0999', '1128', '1230', '1992', '1993', '1994', '1995', '1996', '1997', '1998', '1999', '9999'];
function calcularHashItem(item) {
    return calcularHashDeString(`${item.dataExame}${item.codigoProcedimentoRealizado}${item.ordemExame}${item.indicacaoResultados}${item.observacaoProcedimento}`);
}

const chaveNovoItem = 'n';
const sufixoChaveExcluirItem = '_e';

function Exames(props) {
    // Trecho reservado para ajuste no retorno da modal de inserir/editar item
    const action = useRef(null);
    const ref = useRef(null);

    const [chaveActionRefAtual, setChaveActionRefAtual] = useState(null);
    // Fim de Trecho reservado para ajuste no retorno da modal de inserir/editar item

    const [habilitarEdicaoAtualizacao, setHabilitarEdicaoAtualizacao] = useState(false);
    const [habilitarInsercaoAtualizacao, setHabilitarInsercaoAtualizacao] = useState(false);
    const [mensagemSalvarCamposSemPreenchimento, setMensagemSalvarCamposSemPreenchimento] = useState('');

    const dispatch = useAppDispatch();

    function excluirItem(indice, hashExclusao) {
        const modalConfirmacaoProps = {
            texto: 'Tem certeza que deseja excluir "Exame"?',
            textoBotaoNao: 'Não',
            textoBotaoSim: 'Sim',
            actionBotaoNao: () => {
                setChaveActionRefAtual(hashExclusao);
                retornarFocoParaBotaoChamador(action, ref);
                dispatch(fecharModalConfirmacao());
            },
            actionBotaoSim: async () => {
                props.setModelo({
                    ...props.modelo, listaExames: props.modelo.listaExames.filter((l) => l !== props.modelo.listaExames[indice])
                });

                // Ao excluir um item, retornar o foco ao botão de inclusão de novo item
                setChaveActionRefAtual(chaveNovoItem);
                retornarFocoParaBotaoChamador(action, ref);
            }
        };

        dispatch(abrirModalConfirmacao(modalConfirmacaoProps));
    }

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};

    objetoComponentesTocados['itemExameAuxiliar.dataExame'] = false;
    objetoComponentesTocados['itemExameAuxiliar.ordemExame'] = false;
    objetoComponentesTocados['itemExameAuxiliar.codigoProcedimentoRealizado'] = false;
    objetoComponentesTocados['itemExameAuxiliar.observacaoProcedimento'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    // Separação de regras de validação específicas para serem reaproveitadas entre validadores e tags de componentes
    let obrigatoriedadeObservacaoProcedimento = false;

    if (props.modelo !== null) {
        obrigatoriedadeObservacaoProcedimento =
            listaProcedimentoObrigatoriedadeObservacaoProcedimento.indexOf(getStringValue(props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.valor)) >= 0;
    }

    useEffect(() => {
        const objetoRegrasValidacao = {};

        if (props.modelo != null) {
            objetoRegrasValidacao['itemExameAuxiliar.dataExame'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.itemExameAuxiliar.dataExame.valor), new RegraDiaMesAno(props.modelo.itemExameAuxiliar.dataExame.valor)], componenteTocadoFormulario['itemExameAuxiliar.dataExame']);

            // O campo {ordExame} só é obrigatório quando o procedimento realizado é Audiometria tonal ocupacional (procRealizado = [0281])
            objetoRegrasValidacao['itemExameAuxiliar.ordemExame'] = new RegraObrigatoriedade(props.modelo.itemExameAuxiliar.ordemExame.valor, componenteTocadoFormulario['itemExameAuxiliar.ordemExame'] && props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.valor == '0281');

            objetoRegrasValidacao['itemExameAuxiliar.codigoProcedimentoRealizado'] = new RegraObrigatoriedade(props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.valor, componenteTocadoFormulario['itemExameAuxiliar.codigoProcedimentoRealizado']);
            objetoRegrasValidacao['itemExameAuxiliar.observacaoProcedimento'] = new RegraObrigatoriedade(props.modelo.itemExameAuxiliar.observacaoProcedimento.valor, obrigatoriedadeObservacaoProcedimento && componenteTocadoFormulario['itemExameAuxiliar.observacaoProcedimento']);
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [props.modelo, componenteTocadoFormulario]);

    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);

    useEffect(() => {
        const valoresValidacaoFormulario = Object.values(regraValidacaoFormulario).filter((x) => typeof x !== 'boolean');

        if (regraValidacaoFormulario.todosComponentesTocados) {
            if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0) {
                if (!new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                    let mensagem = '';

                    // Verificar se os campos "ordExame" e "indResult" estão preenchidos para exibição da modal de confirmação.
                    // Realizar o processo apenas quando o salvamento de campos sem preenchimento ainda não tiver sido confirmado
                    if (mensagemSalvarCamposSemPreenchimento !== 'salvarCamposSemPreenchimento') {
                        if (getStringValue(props.modelo.itemExameAuxiliar.ordemExame.valor).length === 0
                            && getStringValue(props.modelo.itemExameAuxiliar.indicacaoResultados.valor).length === 0) {
                            mensagem = `os campos "Ordem do Exame" e "Indicação do Resultado" estejam preenchidos`;
                        }
                        else if (getStringValue(props.modelo.itemExameAuxiliar.ordemExame.valor).length === 0) {
                            mensagem = `o campo "Ordem do Exame" esteja preenchido`;
                        }
                        else if (getStringValue(props.modelo.itemExameAuxiliar.indicacaoResultados.valor).length === 0) {
                            mensagem = `o campo "Indicação do Resultado" esteja preenchido`;
                        }
                    }

                    setMensagemSalvarCamposSemPreenchimento(mensagem);

                    if (mensagem.length === 0) {
                        // Realizar a validação da data do exame baseada na data de emissão do atestado
                        const valorDataExame = props.modelo.itemExameAuxiliar.dataExame.valor;
                        const valorDataEmissaoAtestado = props.modelo.dataASO.valor;

                        if (!isUndefinedOrNull(valorDataEmissaoAtestado)
                            && !isUndefinedOrNull(valorDataExame)
                            && valorDataEmissaoAtestado < valorDataExame) {
                            dispatch(substituirMensagens([{ tipo: TipoMensagem.Erro, texto: 'A data do exame deve ser menor ou igual à data de emissão do atestado de saúde ocupacional.', idContainerMensagem: idBlocoMensagensModalExames, resistente: false }]));
                            rolarVisualizacaoAteElemento(idBlocoMensagensModalExames);
                        }
                        else {
                            if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'inserirItem') {
                                inserirItem();
                            }
                            else if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'editarItem') {
                                editarItem();
                            }

                            retornarFocoParaBotaoChamador(action, ref);
                        }
                    }
                }
                else {
                    rolarVisualizacaoAteElementoInvalido('modalExames');
                }
            }

            setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
        }

    }, [nomeFuncaoAcaoFormularioCompletamenteValidado, regraValidacaoFormulario.todosComponentesTocados]);

    const habilitarEdicaoItem = () => {
        dispatch(limparMensagens([idBlocoMensagensModalExames]));
        setHabilitarEdicaoAtualizacao(true);
    };

    function cancelar() {
        setHabilitarEdicaoAtualizacao(false);
        setHabilitarInsercaoAtualizacao(false);

        // Limpar os valores dos campos auxiliares
        props.setModelo({
            ...props.modelo,
            itemExameAuxiliar: {
                dataExame: { ...props.modelo.itemExameAuxiliar.dataExame, valor: null },
                codigoProcedimentoRealizado: { ...props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado, valor: '' },
                ordemExame: { ...props.modelo.itemExameAuxiliar.ordemExame, valor: '' },
                indicacaoResultados: { ...props.modelo.itemExameAuxiliar.indicacaoResultados, valor: '' },
                observacaoProcedimento: { ...props.modelo.itemExameAuxiliar.observacaoProcedimento, valor: '' }
            }
        });

        retornarFocoParaBotaoChamador(action, ref);
    }

    function novoItem() {
        dispatch(limparMensagens([idBlocoMensagensModalExames]));
        setComponenteTocadoFormulario(obterObjetoTodosComponentesIntocados(componenteTocadoFormulario));
        setHabilitarInsercaoAtualizacao(true);
        setChaveActionRefAtual(chaveNovoItem);
    }

    function inserirItem() {
        const exameItemLista = {
            dataExame: props.modelo.itemExameAuxiliar.dataExame.valor.toLocaleDateString('pt-BR'),
            codigoProcedimentoRealizado: props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.valor,
            descricaoProcedimentoRealizado: props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.fonteDados[props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.valor].split(" - ")[1],
            ordemExame: props.modelo.itemExameAuxiliar.ordemExame.valor,
            descricaoOrdemExame: props.modelo.itemExameAuxiliar.ordemExame.fonteDados[props.modelo.itemExameAuxiliar.ordemExame.valor],
            indicacaoResultados: props.modelo.itemExameAuxiliar.indicacaoResultados.valor,
            descricaoIndicacaoResultados: props.modelo.itemExameAuxiliar.indicacaoResultados.fonteDados[props.modelo.itemExameAuxiliar.indicacaoResultados.valor],
            observacaoProcedimento: props.modelo.itemExameAuxiliar.observacaoProcedimento.valor
        };

        props.setModelo({
            ...props.modelo, listaExames: [...props.modelo.listaExames, exameItemLista],
            itemExameAuxiliar: {
                dataExame: { ...props.modelo.itemExameAuxiliar.dataExame, valor: null },
                codigoProcedimentoRealizado: { ...props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado, valor: '' },
                ordemExame: { ...props.modelo.itemExameAuxiliar.ordemExame, valor: '' },
                indicacaoResultados: { ...props.modelo.itemExameAuxiliar.indicacaoResultados, valor: '' },
                observacaoProcedimento: { ...props.modelo.itemExameAuxiliar.observacaoProcedimento, valor: '' }
            }
        });

        setHabilitarInsercaoAtualizacao(false);
    }

    function copiarItem(indice, hash) {
        habilitarEdicaoItem();

        let data = new Date(props.modelo.listaExames[indice].dataExame.substr(6, 4) + "-" + props.modelo.listaExames[indice].dataExame.substr(3, 2) + "-" + props.modelo.listaExames[indice].dataExame.substr(0, 2));

        props.setModelo({
            ...props.modelo,
            itemExameAuxiliar: {
                chave: indice,
                dataExame: { ...props.modelo.itemExameAuxiliar.dataExame, valor: data.setDate(data.getDate() + 1) },
                codigoProcedimentoRealizado: { ...props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado, valor: props.modelo.listaExames[indice].codigoProcedimentoRealizado },
                ordemExame: { ...props.modelo.itemExameAuxiliar.ordemExame, valor: props.modelo.listaExames[indice].ordemExame },
                indicacaoResultados: { ...props.modelo.itemExameAuxiliar.indicacaoResultados, valor: props.modelo.listaExames[indice].indicacaoResultados },
                observacaoProcedimento: { ...props.modelo.itemExameAuxiliar.observacaoProcedimento, valor: props.modelo.listaExames[indice].observacaoProcedimento }
            }
        });

        setChaveActionRefAtual(hash);
    }

    function editarItem() {
        const exameItemLista = {
            dataExame: new Date(props.modelo.itemExameAuxiliar.dataExame.valor).toLocaleDateString('pt-BR'),
            codigoProcedimentoRealizado: props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.valor,
            descricaoProcedimentoRealizado: props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.fonteDados[props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.valor].split(" - ")[1],
            ordemExame: props.modelo.itemExameAuxiliar.ordemExame.valor,
            descricaoOrdemExame: props.modelo.itemExameAuxiliar.ordemExame.fonteDados[props.modelo.itemExameAuxiliar.ordemExame.valor],
            indicacaoResultados: props.modelo.itemExameAuxiliar.indicacaoResultados.valor,
            descricaoIndicacaoResultados: props.modelo.itemExameAuxiliar.indicacaoResultados.fonteDados[props.modelo.itemExameAuxiliar.indicacaoResultados.valor],
            observacaoProcedimento: props.modelo.itemExameAuxiliar.observacaoProcedimento.valor
        };

        // Nesse ponto sabemos que o item pôde ser editado e chave para localização do botão com action e ref
        // de destino do foco deve ser recalculado em termos dos componentes do item
        const hash = calcularHashItem(exameItemLista);
        setChaveActionRefAtual(hash);

        let chaveAlteracao = props.modelo.itemExameAuxiliar.chave;

        props.setModelo({
            ...props.modelo, listaExames: [...props.modelo.listaExames.filter((l) => l !== props.modelo.listaExames[chaveAlteracao]), exameItemLista],
            itemExameAuxiliar: {
                dataExame: { ...props.modelo.itemExameAuxiliar.dataExame, valor: null },
                codigoProcedimentoRealizado: { ...props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado, valor: '' },
                ordemExame: { ...props.modelo.itemExameAuxiliar.ordemExame, valor: '' },
                indicacaoResultados: { ...props.modelo.itemExameAuxiliar.indicacaoResultados, valor: '' },
                observacaoProcedimento: { ...props.modelo.itemExameAuxiliar.observacaoProcedimento, valor: '' }
            }
        });

        setHabilitarEdicaoAtualizacao(false);
    }

    function atualizarItem() {
        setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
        setNomeFuncaoAcaoFormularioCompletamenteValidado(habilitarEdicaoAtualizacao ? 'editarItem' : 'inserirItem');
    }

    function fecharSalvarCamposSemPreenchimento() {
        setMensagemSalvarCamposSemPreenchimento('');
    }

    function salvarCamposSemPreenchimento() {
        // String que servirá de indicador para que o fluxo de salvamento do exame aconteça
        // mesmo que campos estejam sem preenchimento
        setMensagemSalvarCamposSemPreenchimento('salvarCamposSemPreenchimento');
        atualizarItem();
    }

    return (
        (props.modelo !== null && Object.values(regraValidacaoFormulario).length > 0) &&
        <Fragment>
            <Fieldset legend="Exames" spacing={4}>
                <Display show={!props.somenteVisualizacao}>
                    <Grid item style={{ flexBasis: '100%', paddingTop: '0.3rem' }}>
                        <Button color="primary"
                            startIcon={<AddIcon />}
                            onClick={() => novoItem()}
                            disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                            action={chaveActionRefAtual === chaveNovoItem ? action : undefined}
                            ref={chaveActionRefAtual === chaveNovoItem ? ref : undefined}
                        >
                            Incluir Exame
                        </Button>
                    </Grid>
                </Display>

                <Display show={props.modelo.listaExames.length > 0}>
                    <Grid item style={{ flexBasis: '100%' }}>
                        <CustomTable>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Data Exame</TableCell>
                                    <TableCell align="center">Procedimento Realizado</TableCell>
                                    <TableCell align="center">Ordem</TableCell>
                                    <TableCell align="center">Indicação Resultados</TableCell>
                                    <TableCell align="center">Observação</TableCell>
                                    <Display show={!props.somenteVisualizacao}>
                                        <TableCell align="center">Ação</TableCell>
                                    </Display>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.modelo.listaExames.map((linha, indice) => {
                                    const hash = calcularHashItem(linha);
                                    const hashExclusao = `${hash}${sufixoChaveExcluirItem}`;

                                    return (
                                        <TableRow key={indice}>
                                            <TableCell align="center">{linha.dataExame}</TableCell>
                                            <TableCell align="center">{linha.codigoProcedimentoRealizado + ' - ' + linha.descricaoProcedimentoRealizado}</TableCell>
                                            <TableCell align="center">{getStringValue(linha.ordemExame).length > 0 ? (linha.ordemExame + ' - ' + linha.descricaoOrdemExame) : ''}</TableCell>
                                            <TableCell align="center">{getStringValue(linha.indicacaoResultados).length ? (linha.indicacaoResultados + ' - ' + linha.descricaoIndicacaoResultados) : ''}</TableCell>
                                            <TableCell align="center">{linha.observacaoProcedimento}</TableCell>
                                            <Display show={!props.somenteVisualizacao}>
                                                <ContainerBotoesTabelaAcao align="center">
                                                    <ButtonTextPrimary
                                                        color="inherit"
                                                        size="small"
                                                        aria-label="editar item"
                                                        onClick={() => copiarItem(indice, hash)}
                                                        disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                                        action={chaveActionRefAtual === hash ? action : undefined}
                                                        ref={chaveActionRefAtual === hash ? ref : undefined}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </ButtonTextPrimary>

                                                    <IconButton
                                                        color="inherit"
                                                        size="small"
                                                        aria-label="excluir item"
                                                        onClick={() => excluirItem(indice, hashExclusao)}
                                                        disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                                        action={chaveActionRefAtual === hashExclusao ? action : undefined}
                                                        ref={chaveActionRefAtual === hashExclusao ? ref : undefined}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </ContainerBotoesTabelaAcao>
                                            </Display>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </CustomTable>
                    </Grid>
                </Display>

                <Display show={props.modelo.listaExames.length < 1}>
                    <Grid item style={{ flexBasis: '100%' }}>
                        <Typography>Nenhum exame cadastrado</Typography>
                    </Grid>
                </Display>
            </Fieldset>

            {/*Modal para inserção/edição de exame*/}
            <Dialog
                open={(habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao) && !props.somenteVisualizacao}
                onClose={() => { cancelar() }}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth={false}
                PaperProps={{ id: 'modalExames' }}
            >
                <CustomDialogTitle id="form-dialog-title">{habilitarInsercaoAtualizacao ? 'Incluir' : 'Editar'} Exame</CustomDialogTitle>
                <CustomDialogContent>
                    <Mensagens id={idBlocoMensagensModalExames} />

                    <Fieldset spacing={4}>
                        <VepDatePicker
                            accessor="itemExameAuxiliar.dataExame"
                            label="Qual a data do exame?"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={3}
                            required
                            {...regraValidacaoFormulario['itemExameAuxiliar.dataExame'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemExameAuxiliar.dataExame': true })}
                        />

                        <VepSelect
                            accessor="itemExameAuxiliar.ordemExame"
                            label="Qual a ordem do exame?"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={3}
                            required={props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.valor == '0281'}
                            {...regraValidacaoFormulario['itemExameAuxiliar.ordemExame'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemExameAuxiliar.ordemExame': true })}
                            emptyOption
                        />

                        <CustomAutocomplete
                            md={8}
                            options={props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.fonteDadosAutocomplete}
                            getOptionLabel={(option) => option.rotulo}
                            value={obterOpcaoAutocompletePorValorVep(props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.fonteDadosAutocomplete, props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.valor)}
                            onChange={(event, newValue) => {
                                props.setModelo({ ...props.modelo, itemExameAuxiliar: { ...props.modelo.itemExameAuxiliar, codigoProcedimentoRealizado: { ...props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado, valor: newValue != null ? newValue.valor : '' } } });
                            }}
                            inputProps={{
                                label: 'Qual o procedimento realizado?',
                                title: props.modelo.itemExameAuxiliar.codigoProcedimentoRealizado.descricao,
                                required: true,
                                ...regraValidacaoFormulario['itemExameAuxiliar.codigoProcedimentoRealizado'].obterPropriedadesValidacao(),
                                onBlur: () => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemExameAuxiliar.codigoProcedimentoRealizado': true })
                            }}
                        />

                        <VepSelect
                            accessor="itemExameAuxiliar.indicacaoResultados"
                            label="Qual a indicação do resultado?"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={4}
                            emptyOption
                        />

                        <VepTextField
                            accessor="itemExameAuxiliar.observacaoProcedimento"
                            label="Alguma observação sobre o exame?"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={12}
                            multiline
                            rows={4}
                            maxLength={999}
                            required={obrigatoriedadeObservacaoProcedimento}
                            {...regraValidacaoFormulario['itemExameAuxiliar.observacaoProcedimento'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemExameAuxiliar.observacaoProcedimento': true })}
                        />
                    </Fieldset>
                </CustomDialogContent>
                <CustomDialogActions>
                    <Button variant="text" color="secondary" onClick={() => cancelar()}>
                        Cancelar
                    </Button>
                    <Button variant="text" color="primary" onClick={() => atualizarItem()}>
                        Salvar
                    </Button>
                </CustomDialogActions>
            </Dialog>

            {/*Modal para confirmação de inclusão/alteração de exame sem campos preenchidos*/}
            <Dialog
                open={mensagemSalvarCamposSemPreenchimento.length > 0 && !props.somenteVisualizacao}
                onClose={() => { fecharSalvarCamposSemPreenchimento() }}
                aria-labelledby="form-dialog-title-confirmar-sem-preenchimento"
                maxWidth={false}
            >
                <CustomDialogTitle id="form-dialog-title-confirmar-sem-preenchimento">Atenção!</CustomDialogTitle>
                <CustomDialogContent>
                    <Typography>Deseja salvar exame sem que {mensagemSalvarCamposSemPreenchimento}?</Typography>
                </CustomDialogContent>
                <CustomDialogActions>
                    <Button variant="text" color="secondary" onClick={() => fecharSalvarCamposSemPreenchimento()}>
                        Cancelar
                    </Button>
                    <Button variant="text" color="primary" onClick={() => salvarCamposSemPreenchimento()}>
                        Salvar
                    </Button>
                </CustomDialogActions>
            </Dialog>
        </Fragment>
    );
}
/* fim de exames */
export default Exames;
